const getCurrentStep = (step, currentValue) => {
    if (typeof step === 'number') {
        return step;
    }
    if (Array.isArray(step)) {
        for (let index = step.length - 1; index >= 0; index--) {
            const fromValueKey = step[index].from;
            if (currentValue >= fromValueKey) {
                return step[index].step;
            }
        }
    }
    return 1;
};

export { getCurrentStep };
//# sourceMappingURL=getCurrentStep.js.map
